/**
 * Pipeline: sanitize → validate → enrich (metadata em eventData).
 */

import type { SendEventParams } from '../utils/sendEvent';
import { sanitizeMetadata } from './sanitizeMetadata';
import { validateEventParams } from './validateEvent';

export interface PipelineInput {
  params: SendEventParams;
  metadata?: Record<string, unknown>;
}

export interface PipelineOutput {
  params: SendEventParams | null;
  error?: string;
}

export function runEventPipeline(input: PipelineInput): PipelineOutput {
  const meta = sanitizeMetadata(input.metadata);
  const eventData = {
    ...(input.params.eventData ?? {}),
    ...(meta ? { metadata: meta } : {}),
  };
  const params: SendEventParams = {
    ...input.params,
    eventData,
  };
  const validation = validateEventParams(params);
  if (!validation.valid) {
    return { params: null, error: validation.error };
  }
  return {
    params: {
      ...params,
      eventData: validation.redactedData ?? eventData,
    },
  };
}
